import styled from 'styled-components';
import { ampli } from '../../../../ampli/index';
import { GoToListPageButton } from '../../../../components/common/buttons/GoToListPageButton';
import { SwiperItemContainer } from '../../../../components/common/itemContainer/SwiperItemContainer';
import { INewProduct } from '../../../../interfaces/NewProduct.interfaces';
import { NewProductPreviewCard } from './NewProductPreviewCard';

interface NewProductPreviewCardSwiperProps {
  products: INewProduct[];
}

const SLIDE_WIDTH = 142;
const SLIDE_HEIGHT = 225;

export const NewProductPreviewCardSwiper = ({ products }: NewProductPreviewCardSwiperProps) => {
  return (
    <Wrapper id={'new-product-swiper-container'}>
      <SwiperItemContainer
        slideItemWidth={SLIDE_WIDTH}
        slideItems={products.map((product) => (
          <NewProductPreviewCard
            key={product.id}
            product={product}
            renderedIn={'how-about-new-product'}
            onClick={() => {
              ampli.pvmClickHomeNewProductCard({
                id: product.id,
                title: product.title,
                price: product.price,
                negotiation_yn: product.negotiationYn,
                installment_yn: product.installmentYn,
              });
            }}
          />
        ))}
        extraElement={{
          width: 150,
          element: <GoToListPageButton renderedIn={'home'} itemType={'new-product'} height={SLIDE_HEIGHT} />,
        }}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;
